import { SvgIconProps } from "@mui/material";
import type { IconProps } from "types";

const Import = ({ onClick, color = "#141516", width = "16px", height = "16px", style }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} style={style}>
      <path d="M0.5 14.8332H15.5V16.4998H0.5V14.8332ZM8.83333 9.9765L13.8925 4.9165L15.0708 6.09484L8 13.1665L0.929167 6.09567L2.1075 4.9165L7.16667 9.97484V0.666504H8.83333V9.9765Z" fill={color} />
</svg>

  )
//   return (
//     <svg
//       onClick={onClick}
//       cursor="pointer"
//       width={width}
//       height={height}
//       viewBox="0 0 16 16"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <g clipPath="url(#clip0_356_8601)">
//         <path
//           d="M2 12.6668H14V14.0002H2V12.6668ZM8.66667 8.7815L12.714 4.7335L13.6567 5.67616L8 11.3335L2.34333 5.67683L3.286 4.7335L7.33333 8.78016V1.3335H8.66667V8.7815Z"
//           fill={color}
//           width={width}
//           height={height}
//         />
//       </g>
//       <defs>
//         <clipPath id="clip0_356_8601">
//           <rect width={"16"} height="16" fill="white" />
//         </clipPath>
//       </defs>
//     </svg>
//   );
};

export default Import;
